export default {
  name: 'menu1-2',
  data() {
    return {};
  }
};